var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAllProjects(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 28,
    viewBox: "0 0 32 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5999 8.16004L17.9999 2.04004L12.8399 4.92004L10.2799 2.20004L2.15991 2.16004V25.92H29.7999V8.16004H25.5999ZM17.8799 3.48004L23.6799 8.12004H15.8799L13.7199 5.80004L17.8799 3.48004ZM28.6399 24.76H3.35991V3.36004L9.75991 3.40004L15.3599 9.32004H28.5999V24.76H28.6399Z",
    fill: "#9E6400"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3599 20.0801H6.63989V21.2801H25.3599V20.0801Z",
    fill: "#9E6400"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllProjects);
export default __webpack_public_path__ + "static/media/all_projects.b4e150722bda56ff721fc0a2aca17d07.svg";
export { ForwardRef as ReactComponent };